import { SALE_CONFIG } from '@/saleConfig'

export const SALE_SECTION_CONFIG = {
  all: {
    // No category filter for "all" - this page is product-type agnostic
    productTypeFilter: 'all',
    supportsStockFilter: true,
    title: 'All Discounted Magic',
    sidebarLabel: 'All Discounts',
    cardLabel: 'All Discounts',
    resultCountLabel: 'discounted products',
    cardImage: SALE_CONFIG.saleSectionImages.all,
    metaDescription: 'Shop all discounted magic at Vanishing Inc.',
    introText:
      'Browse every discounted trick, book, ebook, and download in one place. New deals are added regularly, so check back for fresh savings on magic from Vanishing Inc.',
    emptyState: {
      heading: 'No discounted products right now',
      body: "We don't have any discounts running at the moment — check back soon.",
      browseHref: '/magic-tricks/',
      browseLabel: 'Browse our latest magic',
    },
  },
  'magic-tricks': {
    // Product type driven (not category driven)
    productTypeFilter: 'tricks',
    supportsStockFilter: true,
    title: 'Discounted Magic Tricks',
    sidebarLabel: 'Magic Tricks',
    cardLabel: 'Tricks',
    resultCountLabel: 'discounted tricks',
    cardImage: SALE_CONFIG.saleSectionImages.magicTricks,
    metaDescription: 'Shop discounted magic tricks at Vanishing Inc.',
    introText:
      'Save on card tricks, coin magic, mentalism, and more. These are the best current discounts on magic tricks from Vanishing Inc.',
    emptyState: {
      heading: 'No discounted tricks right now',
      body: 'There aren’t any discounted tricks at the moment.',
      browseHref: '/magic-tricks/',
      browseLabel: 'Browse all magic tricks',
    },
  },
  'magic-books': {
    // Product type driven (not category driven)
    productTypeFilter: 'books',
    supportsStockFilter: true,
    title: 'Discounted Magic Books',
    sidebarLabel: 'Magic Books',
    cardLabel: 'Books',
    resultCountLabel: 'discounted books',
    cardImage: SALE_CONFIG.saleSectionImages.magicBooks,
    metaDescription: 'Shop discounted magic books at Vanishing Inc.',
    introText:
      'Find reduced prices on magic books covering theory, technique, and performance. A great way to expand your library for less.',
    emptyState: {
      heading: 'No discounted books right now',
      body: 'There aren’t any discounted books at the moment.',
      browseHref: '/magic-books/',
      browseLabel: 'Browse all magic books',
    },
  },
  ebooks: {
    // Product type driven (not category driven)
    productTypeFilter: 'ebooks',
    supportsStockFilter: false,
    title: 'Discounted Magic Ebooks',
    sidebarLabel: 'Ebooks',
    cardLabel: 'Ebooks',
    resultCountLabel: 'discounted ebooks',
    cardImage: SALE_CONFIG.saleSectionImages.ebooks,
    metaDescription: 'Shop discounted ebooks at Vanishing Inc.',
    introText:
      'Instantly download discounted magic ebooks. Read on any device and start learning new material right away.',
    emptyState: {
      heading: 'No discounted ebooks right now',
      body: 'There aren’t any discounted ebooks at the moment.',
      browseHref: '/ebooks/',
      browseLabel: 'Browse all ebooks',
    },
  },
  downloads: {
    // Product type driven (not category driven)
    productTypeFilter: 'downloads',
    supportsStockFilter: false,
    title: 'Discounted Magic Downloads',
    sidebarLabel: 'Downloads',
    cardLabel: 'Downloads',
    resultCountLabel: 'discounted downloads',
    cardImage: SALE_CONFIG.saleSectionImages.downloads,
    metaDescription: 'Shop discounted downloads at Vanishing Inc.',
    introText:
      'Shop video downloads and digital magic products at reduced prices. Watch, learn, and perform without waiting for shipping.',
    emptyState: {
      heading: 'No discounted downloads right now',
      body: 'There aren’t any discounted downloads at the moment.',
      browseHref: '/magic-downloads/',
      browseLabel: 'Browse all downloads',
    },
  },
} as const

export type SaleSectionSlug = keyof typeof SALE_SECTION_CONFIG
